import React from "react";

export default function FounderDeskBox({ Datateam }) {
  return (
    <>
      <div className="row g-4 mb-5">
        <div className="col-xl-3 col-lg-6 teamDev">
          <div className="propertie-image">
            {Datateam.teamimg !== "" ? (
              <img
                src={Datateam.teamimg}
                alt={Datateam.image_alt}
                title={Datateam.image_title}
              />
            ) : (
              <img src="assets/img/home-3/team/team5.jpg" alt="img" />
            )}
            <div className="team-content text-center mt-3">
              <h4> {Datateam?.name || ""}</h4>
              <p className="text-center">{Datateam?.designation || ""}</p>
            </div>
          </div>
        </div>
        <div className="col-xl-9 col-lg-6">
          <div className="content">
            <p className="wow fadeInUp" data-wow-delay=".5s">
              {Datateam?.description || ""}
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
